
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AlgoType, Device, HeatingAlgoFields } from '~/interfaces/device.interface';
import { DevicesModule } from '~/store/modules/devices';
import SelectAlgoType from '~/components/Device/HeatingAlgo/SelectAlgoType.vue';
import AlgoFields from '~/components/Device/HeatingAlgo/AlgoFields.vue';

@Component({
    components: {
        SelectAlgoType,
        AlgoFields,
    },
})
export default class HeatingAlgo extends Vue {
    @Prop() heatingAlgo!: HeatingAlgoFields;
    @Prop() device!: Device;
    localHeatingAlgoType: AlgoType = 'simple_algo';

    @Watch('heatingAlgo', { immediate: true, deep: true })
    handler(heatingAlgo: HeatingAlgoFields): void {
        this.localHeatingAlgoType = heatingAlgo.simple_algo ? 'simple_algo' : 'pid_algo';
    }

    setHeatingAlgoType(): void {
        if (this.device) {
            this.device.setHeatingAlgoType(this.localHeatingAlgoType);
        }
    }

    get currentGatewayType(): string {
        return DevicesModule.currentGateway ? DevicesModule.currentGateway.type : '';
    }

    recomputeHeating(): void {
        this.device.recomputeHeating();
    }
}
